/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldLinkSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldLinkSmall',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"m12.865 2.327-.192-.192c-.725-.725-1.68-1.087-2.635-1.087s-1.91.362-2.635 1.087l-1.83 1.83a3.74 3.74 0 0 0 0 5.27l.192.193c.154.154.323.283.496.404l.696-.692.38-.38a2.2 2.2 0 0 1-.522-.378L6.62 8.19a2.25 2.25 0 0 1 0-3.18l1.83-1.83c.423-.422.987-.654 1.59-.654s1.17.232 1.59.654l.193.192c.423.422.655.986.655 1.59s-.232 1.168-.654 1.59l-.127.128c.337.475.507 1.03.5 1.59l.674-.674a3.74 3.74 0 0 0 0-5.27zm-3.47 3.085a3.6 3.6 0 0 0-.495-.404L7.828 6.08c.19.102.368.222.523.377l.197.192a2.25 2.25 0 0 1 0 3.18l-1.83 1.83a2.23 2.23 0 0 1-1.59.65 2.23 2.23 0 0 1-1.59-.654l-.193-.193a2.25 2.25 0 0 1 0-3.18l.13-.128a2.7 2.7 0 0 1-.5-1.59l-.674.672a3.74 3.74 0 0 0 0 5.27l.19.19a3.72 3.72 0 0 0 2.636 1.088c.955 0 1.91-.36 2.635-1.086l1.83-1.83a3.74 3.74 0 0 0 0-5.27l-.19-.19z"}))
}
